import Vue from 'vue'
import store from '../store'


class VideonFleet {
  constructor(fleet_guid, fleet_attributes = false) {
    this.fleet_guid = fleet_guid
    this.ready = false
    
    this.editable = false
        
    this.fleet_name = (fleet_attributes) ? fleet_attributes.fleet_name : ''
    
    this.org_guid = (fleet_attributes && fleet_attributes.org_guid) ? fleet_attributes.org_guid : false
    this.org_name = (fleet_attributes && fleet_attributes.org_name) ? fleet_attributes.org_name : false
    
    this.status = false
    this.fetching = false
    
    this.devices = []
    this.itemsPerPage = 50
    
    this.users = []
    this.userInvites = []
    
    this.error = false
    this.errorText = ''
    
    if (!fleet_attributes) {
      this.fetchFleet()
    }
    
    //this.fetchDevices()
    //this.fetchStatus()
  }
  
  refresh() {
    this.fetchFleet()
    this.fetchStatus()
  }
  
  delete() {
    this.fleet_guid = false
    Vue.delete(this) // this shouldnt work.. but it does...
  }
  
  displayName() {
    return (this.fleet_name) ? Vue.helpers.htmlDecode(this.fleet_name) : 'loading...'
  }
  
  canEdit() {
    return this.editable
  }
  
  fetchFleet() {
    if (!this.fleet_guid) {
      return
    }
    Vue.axios.get('/fleets/' + this.fleet_guid)
    .then((response) => {
      console.log('VideonFleet ' + this.fleet_guid + ' fetchFleet response', response.data)
      
      this.fleet_name = response.data.fleet.fleet_name
      
      if (response.data.fleet.org_guid) {
        this.org_guid = response.data.fleet.org_guid
      }
      if (response.data.fleet.org_name) {
        this.org_name = response.data.fleet.org_name
      }
      
    }).catch((error) => {
      this.error = true
      this.errorText = Vue.helpers.parseError(error)
    })
  }
  
  async fetchDevices() {
    if (!this.fleet_guid) {
      return
    }
    
    var newDevices = []
    
    var queryParams = {
      'pagination_size': this.itemsPerPage
    }
  
    var paginationToken = false
    
    try {
      do {
        if (paginationToken) {
          queryParams.pagination_token = paginationToken
        }
        
        let response = await Vue.axios.get('/fleets/' + this.fleet_guid + '/devices', {'params': queryParams})
        console.log('VideonFleet ' + this.fleet_guid + ' fetchDevices response', response)
        
        if (response.data.devices.length > 0) {
          newDevices = newDevices.concat(
            response.data.devices.map((device) => Vue.devices.getDevice(device.device_guid, device))
          )
          
          if (response.data.pagination_token) {
            paginationToken = response.data.pagination_token
          } else {
            paginationToken = false
          }
        }
      } while (paginationToken)

      this.devices = newDevices
      this.ready = true
    } catch (error) {
      console.log('VideonFleet ' + this.fleet_guid + ' fetchDevices error', error)
    }
  }
  
  async fetchUsers() {
    if (!this.fleet_guid) {
      return
    }
    
    var newUsers = []
    
    var queryParams = {
      'pagination_size': this.itemsPerPage
    }
  
    var paginationToken = false
    
    try {
      do {
        if (paginationToken) {
          queryParams.pagination_token = paginationToken
        }
        
        let response = await Vue.axios.get('/fleets/' + this.fleet_guid + '/users', {'params': queryParams})
        console.log('VideonFleet ' + this.fleet_guid + ' fetchUsers response', response)

        if (response.data.users && response.data.users.length > 0) {
          newUsers = newUsers.concat(response.data.users)
        }
        if (response.data.pagination_token) {
          paginationToken = response.data.pagination_token
        } else {
          paginationToken = false
        }
      } while (paginationToken)
    } catch (error) {
      console.log('VideonFleet ' + this.fleet_guid + ' fetchUsers error', error)
    }
    
    this.users = newUsers
    this.resolveUserPermissions()
  }
  
  fetchUserInvites() {
    if (!this.fleet_guid) {
      return
    }
    Vue.axios.get('/invites', {params: {'fleet_guid': this.fleet_guid}}).then((response) => {
      console.log('VideonFleet ' + this.fleet_guid + ' fetchUserInvites response', response)
      
      this.userInvites = response.data.invites
    }).catch(() => {
      // do nothing...
    })
  }
  
  resolveUserPermissions() {
    if (store.getters['user/isOrgAdmin']) {
      this.editable = true
      return
    }
    
    let myGUID = store.getters['user/guid']
    
    for (var i in this.users) {
      var user = this.users[i]
      // if this user has appropriate permissions enable editable flag
      if (myGUID == user.user_guid && user.access > 200) {
        console.log('VideonFleet ' + this.fleet_guid + ' resolveUserPermissions user can edit device')
        this.editable = true
        this.controllable = true
        return
      } else if (myGUID == user.user_guid && user.access > 100) {
        console.log('VideonFleet ' + this.fleet_guid + ' resolveUserPermissions user can control device')
        this.controllable = true
        return
      }
    }
  }
  
  fetchStatus() {
    if (!this.fleet_guid) {
      return
    }
    
    if (this.fetching) {
      return
    }
    
    if (!this.ready || document.hasFocus()) {
      this.fetching = true
      Vue.axios.get('/fleets/' + this.fleet_guid + '/devices/status')
      .then((response) => {
        this.fetching = false
        
        console.log('VideonFleet ' + this.fleet_guid + ' fetchStatus response', response)
        
        this.status = response.data.status
        
        this.error = false
        this.errorText = ''
      }).catch((error) => {
        this.error = true
        this.errorText = Vue.helpers.parseError(error)
      })
    }
  }
}

export default new class VideonFleets {
  constructor() {
    this.fleets = []
  }
  
  reset() {
    console.log('VideonFleets reset')
    
    // invalidate device_guids
    for (var x in this.fleets) {
      console.log('VideonFleets reset invalidating', this.fleets[x].fleet_guid)
      this.fleets[x].delete()
    }
    
    // reset array
    this.fleets.splice(0)
  }
  
  invalidateFleet(fleet_guid) {
    for (var i = this.fleets.length - 1; i >= 0; --i) {
      if (this.fleets[i].fleet_guid == fleet_guid) {
        console.log('VideonFleets invalidateFleet', fleet_guid)
        this.fleets[i].delete()
        this.fleets.splice(i,1)
        return
      }
    }
  }
  
  getFleet(fleet_guid, fleet_attributes = false) {
    if (!fleet_guid) {
      console.log('Fleets getFleet missing fleet_guid', fleet_guid, fleet_attributes)
      return false
    }
    
    var fleet = this.fleets.find(x => x.fleet_guid === fleet_guid)
    if (fleet) {
      if (fleet_attributes) {
        if (!fleet.org_guid && fleet_attributes.org_guid) {
          fleet.org_guid = fleet_attributes.org_guid
        }
        if (!fleet.org_name && fleet_attributes.org_name) {
          fleet.org_name = fleet_attributes.org_name
        }
        if (fleet_attributes.fleet_name && !fleet.fleet_name) {
          fleet.fleet_name = fleet_attributes.fleet_name
        }
        if (fleet_attributes.access != null && fleet.access == null) {
          fleet.access = fleet_attributes.access
        }
      }
      return fleet
    }
    
    fleet = Vue.observable(new VideonFleet(fleet_guid, fleet_attributes))
    this.fleets.push(fleet)
    
    return fleet
  }
}